<template>
    <v-row>
        <v-col>            
            <v-row>
                <v-col cols="12">
                    <base-card>
                        <v-card-title>                                                                                    
                            <div class="d-flex justify-space-between" style="width: 100%;">
                                <div class="d-flex justify-space-between">                                       
                                    <!--<img class="ma-1- mx-0"  src="/icon-small.jpg" height="36" />-->
                                    <h5 class="ma-1 mt-6" >Offline Placements</h5> 
                                </div>                                 
                                <div class="d-flex flex">
                                    <v-select class="ml-4"   label="Select Network" v-model="selectedNetwork" :items="networkOptions"></v-select>
                                </div>
                                <div v-if="false" class="d-flex flex">
                                    <v-select class="ml-4"   label="Select Cluster" v-model="selectedCluster" :items="clusterOptions" clearable></v-select>
                                </div>
                                <div style="width: 220px;"> 
                                    <v-menu                                    
                                        ref="calcDatepicker"
                                        v-model="calculationDatepickerFrom"
                                        :close-on-content-click="false"
                                        
                                        transition="scale-transition"
                                        offset-y                                        
                                        min-width="290px"
                                    >
                                        <template v-slot:activator="{on, attrs}">
                                            <v-text-field
                                            class="ma-4 mb-0 d-flex flex"
                                                label='From'
                                                dense
                                                outlined
                                                v-model="calculationDateFrom"                                              
                                                readonly
                                                v-bind="attrs"
                                                v-on="on"
                                                hide-details    
                                                :clearable="true"                                                       
                                            ></v-text-field>
                                        </template>
                                        <v-date-picker v-model="calculationDateFrom" :max="datepickerMaxLimit" scrollable style="z-index: 15;">                    
                                        </v-date-picker>
                                    </v-menu>
                                </div>     
                                <div style="width: 220px;"> 

                                    <v-menu                                    
                                    ref="calcDatepicker"
                                    v-model="calculationDatepickerTo"
                                    :close-on-content-click="false"
                                    
                                    transition="scale-transition"
                                    offset-y
                                    min-width="290px"
                                >
                                    <template v-slot:activator="{on, attrs}">
                                        <v-text-field
                                        class="ma-4 mb-0 d-flex flex"                                            
                                            label='To'
                                            dense
                                            outlined
                                            v-model="calculationDateTo"                                              
                                            readonly
                                            v-bind="attrs"
                                            v-on="on"
                                            hide-details    
                                            :clearable="true"                                                       
                                        ></v-text-field>
                                    </template>
                                    <v-date-picker v-model="calculationDateTo" :max="datepickerMaxLimit" scrollable style="z-index: 15;">                    
                                    </v-date-picker>
                                </v-menu>
                                </div>                         
                                <div class="mr-4">
                                    <v-text-field                                        
                                        v-model="quicksearch"
                                        append-icon="mdi-magnify"
                                        label="Search"
                                        single-line
                                        hide-details                                                               
                                        
                                ></v-text-field>
                                </div>
                                <v-btn class="maz-4 mt-4" dark color="primary" @click="getData" :loading="progressStatsLoading">
                                        <v-icon>mdi-reload</v-icon>
                                        Reload
                                </v-btn>
                            </div>
                        </v-card-title>                                        
                        <v-progress-linear
                            :active="progressStatsLoading"
                            :indeterminate="progressStatsLoading"
                            absolute
                            bottom
                            color="deep-purple accent-4" 
                        />
                    </base-card>
                    <!--<div class="d-block text-center mt-8">   @input="triggerTextSearch"
                        <v-progress-circular
                        v-if="progressStatsLoading"
                        indeterminate
                        color="primary"
                        ></v-progress-circular>
                        <div v-else >no cache entries found </div>
                    </div>-->
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12">
                    <base-card>                    
                        <div v-show="placementPlan && placementPlan.length>2" style="padding-right: 20px; padding-top: 40px;">
                            <apexchart
                                width="100%"
                                :height="40 * placementPlan.length"
                                type="rangeBar"
                                :options="placementPlanChartOptionsComputed"
                                :series="placement_plan_adapted"
                            />
                        </div>                      
                    </base-card>
                </v-col>
            </v-row>                                               

            <v-snackbar
                v-model="mysnackbar"
                :timeout="4000"
                bottom
                tile
                color="red"            
                >                
            </v-snackbar>
        </v-col>
    </v-row>
</template>

<script>
import {api, srvApi, srvApiNoAuth, PATH, getAssetUrl} from "src/api/index";
import moment from "moment";
import AdvancedGridFiltersList from "@/components/core/AdvancedGridFiltersList";
import {GGanttChart, GGanttRow} from 'vue-ganttastic';
import { GChart } from 'vue-google-charts/legacy';
import CardDashboard from "@/components/campaigns/CardDashboard";
import ReportRuleComponent from "@/components/campaigns/campaign-report-rule-component";
import {parseDate, formatDate} from '@/core/date-utils.js';
import { integerFormatting } from '@/core/number-utils.js'
// import Gantt from '@salamander.be/vue-gantt/src/components/gantt.vue';
import {
    gradientLineChart,
    salesByCountries,
    visitorsAnalytic
} from '@/data/sales2';
import {
  analyticOne,
  analyticTwo,
  analyticThree,
  analyticFour,
  analyticFive,
} from "@/data/analytic2";

export default {
    metaInfo: {
        // title will be injected into parent titleTemplate
        title: 'Adpoints Management'
    },    
    components: {
        "advanced-grid-filters-list": AdvancedGridFiltersList    ,
        GGanttChart,
        GGanttRow,
        GChart,
        CardDashboard,
        "report-rule-component": ReportRuleComponent
       // Gantt  
    },
    data() {

        let oneDayAgo = new Date();
        oneDayAgo.setDate(oneDayAgo.getDate() - 1);
        let twoWeeksAfter = new Date();
        twoWeeksAfter.setDate(twoWeeksAfter.getDate() + 14);
        let oneEightyDaysAfter = new Date();
        oneEightyDaysAfter.setDate(oneEightyDaysAfter.getDate() + 180);

        return {            
            mysnackbar: false,    
            mysnackbar_msg: "",       
            progressStatsLoading: true,   
            tabs_selection: null,
            
            calculationDateFrom: null,
            calculationDatepickerFrom: null,
            calculationDateTo: null,
            calculationDatepickerTo: null,
            datepickerMaxLimit: null,

            total_adpoints: null,
            total_capacity: null,
            available_impressions: null,
            utilization_pct: null,

            selectedNetwork: '',
            selectedCluster: null,
            quicksearch: '',

            networkOptions: [],

            clusterOptions: [],    
            
            placementPlan: [              
            ],


            placementPlanChartOptions: {
                chart: {
                    // height: 350,
                    type: 'rangeBar'
                },
                plotOptions: {
                    bar: {
                        horizontal: true,
                        rangeBarGroupRows: true,
                        //hideZeroBarsWhenGrouped: true,
                        // distributed: true,
                        dataLabels: {
                            hideOverflowingLabels: true
                        }
                    },
                    dataLabels: {
                        enabled: false
                    }
                },
                //colors: ['#008FFB', '#546E7A', '#1B998B'],
                legend: {
                    show: false
                },
                dataLabels: {
                    enabled: true,
                    formatter: function(val, opts) {
                        var label = opts.w.globals.labels[opts.dataPointIndex];
                        let info = opts.w.globals.initialSeries[opts.seriesIndex].data[opts.dataPointIndex];
                        var a = moment(val[0])
                        var b = moment(val[1])
                        //var c = this.placementPlan[opts.dataPointIndex].assetName;
                        var diff = b.diff(a, 'days')
                        return info.assetName + ' [' + diff + (diff > 1 ? ' days]' : ' day]')
                        //return c + ': ' + label + ': ' + diff + (diff > 1 ? ' days' : ' day')
                    },
                    style: {
                        colors: ['#f3f4f5', '#fff']
                    }
                },
                xaxis: {                    
                    type: 'datetime',
                    position: 'top',
                    labels: {
                    showDuplicates: false,
                    datetimeFormatter: {
                        year: 'yyyy',
                        month: 'MMM \' yy',
                        day: 'dd MMM',
                        hour: 'dd MMM',
                    },                    

                    
                }
                    
                },
                yaxis: {
                    //show: false
                    
                   min: oneDayAgo.getTime(),
                    max: twoWeeksAfter.getTime(),
                    // type: 'datetime',
                    // tickAmount: 1,
                    
                },
                grid: {
                    row: {
                        colors: ['#f3f4f5', '#fff'],
                        opacity: 1
                    }
                },
                tooltip: {
                    custom: function({series, seriesIndex, dataPointIndex, w}) {
                    let info = w.globals.initialSeries[seriesIndex].data[dataPointIndex];
                    return '<div style="padding: 5px; display: inline-flex; display: inline-flex;"><img src="' + info.assetThumbnailUrl + '" alt="" width="60" class="mr-4" /><span style="margin-top: 5px;" class="mr-4">' + info.assetName + '</span></div>';
                    }
                }
            },
        }
    },
    filters: {

    },
    watch: {
      
    },
    computed: {

        placementPlanChartOptionsComputed(){ 

            let staDate = new Date(this.calculationDateFrom);
            let endDate = new Date(this.calculationDateTo);
            return {
                chart: {
                    // height: 350,
                    type: 'rangeBar'
                },
                plotOptions: {
                    bar: {
                        horizontal: true,
                        rangeBarGroupRows: true,                        
                        // distributed: true,
                        dataLabels: {
                            hideOverflowingLabels: false
                        }
                    }
                },
                //colors: ['#008FFB', '#546E7A', '#1B998B'],
                legend: {
                    show: false
                },
                dataLabels: {
                    enabled: false,
                    formatter: function(val, opts) {
                        var label = opts.w.globals.labels[opts.dataPointIndex];
                        let info = opts.w.globals.initialSeries[opts.seriesIndex].data[opts.dataPointIndex];
                        var a = moment(val[0])
                        var b = moment(val[1])
                        //var c = this.placementPlan[opts.dataPointIndex].assetName;
                        var diff = b.diff(a, 'days')
                        return info.assetName + ' [' + diff + (diff > 1 ? ' days]' : ' day]')
                        //return c + ': ' + label + ': ' + diff + (diff > 1 ? ' days' : ' day')
                    },
                    style: {
                        colors: [/*'#fff'*/ '#1e1e1e']
                    },
                    //textAnchor: 'middle',
                    offsetX: 40,
                },
                xaxis: {
                    type: 'datetime',
                    position: 'top',
                    labels: {
                    showDuplicates: false,
                    datetimeFormatter: {
                        year: 'yyyy',
                        month: 'MMM \' yy',
                        day: 'dd MMM',
                        hour: 'dd MMM',
                    }
                }
                    
                },
                yaxis: {
                    //show: false                    
                   min: staDate.getTime(),
                    max: endDate.getTime(),
                    // type: 'datetime',
                    // tickAmount: 1,
                    
                    labels: {
                        //width: 450,
                        align: 'left',
                        minWidth: 150,
                        maxWidth: 500,
                        style: {
                            
                            fontSize: '15px'
                        }
                    }
                },
                grid: {
                    row: {
                        colors: [ /*'#f3f4f5',*/ '#1e1e1e' /*'#fff',*/ ],
                        opacity: 1
                    }
                },
                tooltip: {
                    custom: function({series, seriesIndex, dataPointIndex, w}) {
                        let info = w.globals.initialSeries[seriesIndex].data[dataPointIndex];
                        return '<div style="padding: 5px; display: block; "><img src="' + info.assetThumbnailUrl + '" alt="" width="60" class="mr-4" /><span style="margin-top: 5px;" class="mr-4">' + info.assetName + '</span><br/><span>'+ info.start +'</span><span style="margin-left: 20px;">'+ info.end +'</span><br/><span>Status: ' + info.cmpnstatus + '</span></div>';
                    }
                }
            }
        },




        placement_plan_adapted() {
            return this.placementPlan;

            let srcData = this.placementPlan;
            let todayDate = (new Date()).getTime();            
            return [{
                data: srcData.map((item)=> {
                    let eventStart = new Date(item.start.substring(0,10)).getTime();
                    let eventEnd = new Date(item.end.substring(0,10)).getTime();

                    const rslt = {
                        x: '#' + item.ruleNumber + ' placement', //+ item.assetType,
                        y: [
                            eventStart,
                            eventEnd,
                            //'something'
                        ],
                        fillColor: '#008FFB',
                        ...item,
                        ...(
                            eventStart<=todayDate && todayDate<=eventEnd ? {
                                goals: [
                                    {
                                        name: 'Break',
                                        value: todayDate,
                                        strokeColor: '#CD2F2A'
                                    }
                                ]
                            } : {}
                        )
                    };
                    return rslt;
                })
            }]
        },
    },
    methods: {
        async triggerQuicksearch() {
            
        },
        async exportDocument(selectedCampaign) {
            
            await new Promise(resolve => setTimeout(resolve, 12000));
            this.progressStatsLoading = false;
            //this.mysnackbar=true;
            this.progressStatsLoading=false;
        },

        async getData() {
            let qstr = "";

            const limit = 10000;
            const currentPage = 0;
            qstr += "?currentPage=" + currentPage + "&limit=" + limit;
            qstr += "&networkId=" + this.selectedNetwork;
            if(this.selectedCluster) {
                qstr += "&clusterId=" + this.selectedCluster;
            }
            //quicksearch
            if(this.quicksearch && this.quicksearch.length > 0){
                //if(!qstr.includes("?")) qstr = "?" + qstr;
                qstr += "&quicksearch=" + encodeURIComponent(this.quicksearch);
            } 









            this.progressStatsLoading=true;
            try {
                const rsp = await srvApi.post(PATH.REPORTING_OFFLINECALENDAR + '/' + qstr);            
                
                // this.total_adpoints = rsp.data.total_adpoints;
                // this.total_capacity = rsp.data.total_capacity;
                // this.available_impressions = rsp.data.available_impressions;
                // this.utilization_pct = rsp.data.utilization_pct;

                // this.networks.splice(0, this.networks.length);
                // this.networks.push(...rsp.data.networks);

                this.placementPlan.splice(0, this.placementPlan.length);
                this.placementPlan.push(...rsp.data.placementPlan);

            } catch (error) {
                this.mysnackbar_msg= "Error: " + (error.message || error.msg || "Server Error");
                this.mysnackbar=true;
            }
            finally {
                this.progressStatsLoading=false;
            }
            
        }

        
    },
    async created() {
        const rsp = await api.adpoint.getInitData();
        this.networkOptions = rsp.data.networkOptions.filter(o=>o.extra.type == 'static');    
        if(this.networkOptions && this.networkOptions.length>0) {
            this.selectedNetwork = this.networkOptions[0].value;
        }    
        this.clusterOptions = rsp.data.clusterOptions;


        let today = new Date();
        let sevenDaysAgo = new Date();
        sevenDaysAgo.setDate(sevenDaysAgo.getDate() - 7);
        let oneDayAgo = new Date();
        oneDayAgo.setDate(oneDayAgo.getDate() - 1);
        let twoWeeksAfter = new Date();
        twoWeeksAfter.setDate(twoWeeksAfter.getDate() + 14);
        let oneEightyDaysAfter = new Date();
        oneEightyDaysAfter.setDate(oneEightyDaysAfter.getDate() + 180);
        this.calculationDateFrom = oneDayAgo.toISOString().substring(0,10);
        this.calculationDateTo = twoWeeksAfter.toISOString().substring(0,10);
        this.datepickerMaxLimit = oneEightyDaysAfter.toISOString().substring(0,10);

        await this.getData();
    },
    async mounted() {
        //await new Promise(resolve => setTimeout(resolve, 12000));
        // const basicData = await srvApi.get(PATH.NETWORK_ASOPTIONS);
        // this.networkOptions.push(...basicData.data.map(i=>({value: i.extra.code, text: i.text})));

        // if(this.$route.params.code) {
        //     this.code = this.$route.params.code;
        // }      
        // else {
        //     if(this.networkOptions.length>0) {
        //         this.code = this.networkOptions[0].value
        //     }
        // }  
        //await this.getData();
        
        //this.mysnackbar=true;
        //this.progressStatsLoading=false;

        /*
        let ff = this.filterfields.find(i=>i.selectvalue === "brand");        
        if(ff) {
            const rsp = await api.brand.getAll();            
            ff.listItems = rsp.data.map(i=> {return {selectvalue: i.code, selecttext: i.title}});
        }
        */









        // let qstr = "";

        //     const limit = 10000;
        //     const currentPage = 0;
        //     qstr += "?currentPage=" + currentPage + "&limit=" + limit;
        //     qstr += "&networkId=" + this.selectedNetwork;
        //     if(this.selectedCluster && this.selectedCluster.length>0) {
        //         qstr += "&clusterId=" + this.selectedCluster;
        //     }
        //     //quicksearch
        //     if(this.quicksearch && this.quicksearch.length > 0){
        //         //if(!qstr.includes("?")) qstr = "?" + qstr;
        //         qstr += "&quicksearch=" + encodeURIComponent(this.quicksearch);
        //     } 









        //     this.progressStatsLoading=true;
        //     try {
        //         const rsp = await srvApi.post(PATH.REPORTING_OFFLINECALENDAR + '/' + qstr);            
                
        //         // this.total_adpoints = rsp.data.total_adpoints;
        //         // this.total_capacity = rsp.data.total_capacity;
        //         // this.available_impressions = rsp.data.available_impressions;
        //         // this.utilization_pct = rsp.data.utilization_pct;

        //         // this.networks.splice(0, this.networks.length);
        //         // this.networks.push(...rsp.data.networks);

        //         this.placementPlan.splice(0, this.placementPlan.length);
        //         this.placementPlan.push(...rsp.data.placementPlan);

        //     } catch (error) {
        //         this.mysnackbar_msg= "Error: " + (error.message || error.msg || "Server Error");
        //         this.mysnackbar=true;
        //     }
        //     finally {
        //         this.progressStatsLoading=false;
        //     }
    }
}
</script>
<style lang="scss">
.apexcharts-toolbar {
    //background-color: red;
    margin-top: -20px;
    z-index: 2 !important;
}

.apexcharts-menu-icon {
    display: none;
}

tspan {
    white-space: pre;
}

.apexcharts-text {
    white-space: pre;
}

.apexcharts-yaxis {
    white-space: pre;
    background-color: red;
}

.apexcharts-datalabels {
    margin-left: 100px !important;
}

.apexcharts-data-labels {
    margin-left: 100px !important;
}

</style>


<style lang="scss" scoped>

.v-card__title {
    color: #FFF
}

.v-application.primary--text {
    color: #FFF
}

.active {
       color: #222222 !important;
       background-color: #ffff !important;
    }
.apexcharts-toolbar {
    //background-color: red;
    margin-top: -25px;
}
</style>

<style lang="scss" scoped>
.metrics-grid {
    //background-color: red;
    //margin-top: -10px;
    display: grid;
    grid-template-columns: repeat(8, 1fs [col-start]);
    grid-template-rows: [row1-top] 1fs [row2-bottom] 1fs;
    column-gap: 24px;
    row-gap: 12px;
}

.metrics-griditem {
    //background-color: red;
    //margin-top: -10px;
    
    //border: 2px red solid;
}

.v-card .v-list-item {
    // color: #304156 !important;
}

</style>
